import { SnackbarsStackAction, SNACKBARS_STACK_DELETE } from './types';
import { TSnackbarId } from '../types';

export const deleteSnackbar = (
  snackbarId: TSnackbarId
): SnackbarsStackAction => ({
  type: SNACKBARS_STACK_DELETE,
  payload: snackbarId
});
